
import {
    AppButton,
    AppCard,
    AppDateTimePicker,
    AppFileUpload,
    AppFormRow,
    AppImageHolder,
    AppInput,
    AppSelect
} from '@/components';
import { useNewsEdit } from '@/modules/news/model/edit';
import { NewsOptions } from '@/modules/news/model/mixins';
import { ROUTE_NAME_NEWS } from '@/modules/news/router';
import { defineComponent, onMounted } from 'vue';

export default defineComponent({
    name: ROUTE_NAME_NEWS.EDIT,
    components: {
        AppFormRow,
        AppInput,
        AppButton,
        AppCard,
        AppSelect,
        AppDateTimePicker,
        AppFileUpload,
        AppImageHolder
    },
    setup() {
        const { model, v$, fetch, actions } = useNewsEdit();

        onMounted(async () => {
            await fetch();
        });

        return { model, v$, NewsOptions, actions };
    }
});
